import { Spinner } from '../../components';
import { ResultsCardFrame } from '../results/ResultsCardFrame';
import type { ResultSession } from '../results/sessions';
import { useResultSessionStore } from '../results/store';
import type { BoardContextValue } from '../useBoardContext';
import { ExamDetailTab } from './ExamDetailTab';
import { ExamStatsTab } from './ExamStatsTab';
import { examDisplayTitle } from './examResults';
import { useExamResultStore } from './store';
import { useClassExamLoad, useExamResultsView } from './useExamResults';

export interface ExamResultsCardProps {
  session: ResultSession;
  /** No rail for this tab, so the card carries its own Báo cáo | Chi tiết switch. */
  switchable?: boolean;
  context: BoardContextValue;
  onBackToDe: () => void;
}

// Real class results for the exam on this tab
export function ExamResultsCard({ session, context, switchable = false, onBackToDe }: ExamResultsCardProps) {
  const examId = session.refId;
  useClassExamLoad(context);
  const { view, exam, results, names, attemptsLoading, questionsLoading, questionsError, retryQuestions, retryAttempts } = useExamResultsView(examId);
  const titles = useExamResultStore((state) => state.courseTitles);
  const examTitles = useExamResultStore((state) => state.examTitles);
  const setPanelTab = useResultSessionStore((state) => state.setPanelTab);
  const setCollapsed = useResultSessionStore((state) => state.setCollapsed);
  const hide = useResultSessionStore((state) => state.hide);
  const openStudent = useResultSessionStore((state) => state.openStudent);

  const subtitle = exam ? [examDisplayTitle(exam, examTitles), titles[exam.courseId] || ''].filter(Boolean).join(' • ') : session.title;
  const questionNote = questionsLoading ? <Spinner size="small" label="Đang tải câu hỏi…" /> : questionsError
    ? <p className="quiz-results__empty">Chưa tải được câu hỏi: {questionsError} <button type="button" className="hw-panel__refresh" onClick={retryQuestions}>Thử lại</button></p>
    : null;
  const actions = session.student ? <button type="button" className="hw-panel__refresh" onClick={onBackToDe}>Quay lại đề</button> : null;
  const onOpenStudent = (code: string) => openStudent(session.tabId, code);
  const attempt = exam && session.student ? exam.byCode[session.student] : undefined;
  const studentName = session.student ? names[session.student] || (attempt ? attempt.name : session.student) : null;

  return (
    <ResultsCardFrame kindLabel="bài kiểm tra" subtitle={subtitle} actions={actions} view={session.panelTab} onView={switchable ? (view) => setPanelTab(session.tabId, view) : undefined}
      collapsed={session.collapsed} studentName={studentName} onCollapse={() => setCollapsed(session.tabId, true)} onExpand={() => setCollapsed(session.tabId, false)} onClose={() => hide(session.tabId)}>
      {!results ? (view.kind === 'error' ? <p className="quiz-results__empty">Chưa tải được kết quả: {view.message} <button type="button" className="hw-panel__refresh" onClick={retryAttempts}>Thử lại</button></p> : <Spinner label="Đang tải kết quả của lớp…" />)
        : session.panelTab === 'stats' ? <ExamStatsTab results={results} questionNote={questionNote} />
          : <ExamDetailTab results={results} activeCode={session.student} onOpenStudent={onOpenStudent} onReload={retryAttempts} reloading={attemptsLoading} />}
    </ResultsCardFrame>
  );
}
